import styles from './Button.module.css';

function Button({ children, onClick, variant = 'primary', className = '', disabled = false, ...props }) {
    const buttonClass = `${styles.button} ${styles[variant] || styles.primary} ${className}`.trim();

    return (
        <button className={buttonClass} onClick={onClick} disabled={disabled} {...props}>
            {children}
        </button>
    );
}

export default Button;